import $ from 'jquery';
import EmployeeMasterData from './EmployeeMasterData';
import { useDispatch } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import { deleteEmployee, getEmployeeSuccess, start } from '../../store/slices/TeamManagementSlice';
import CreateEmployee from './CreateEmployee';
import { useEffect, useState } from 'react';
import DeleteModal from '../Modals/DeleteModal';
import { remove } from '../../services/upload-files.service';
import ViewModal from '../Modals/ViewModal';

const EmployeeMaster = () => {
  $(function () {
    $(".clickable-row ").on("click", function () {
      $(this).next(".folded-data").toggleClass("open");
    });
  });

  const [show, setShow] = useState(false);
  const [view, setView] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [currentVal, setCurrentVal] = useState(null)
  const [empId, setEmpId] = useState(null)
  const { company_id } = JSON.parse(localStorage.getItem('userdetails'))
  const dispatch = useDispatch();
  const { data } = useFetch(`employee?company_id=${company_id}`)

  useEffect(() => {
    if (data && data.results && data.results.length > 0) {
      dispatch(getEmployeeSuccess(data));
    } else {
      dispatch(start());
    }
  }, [data, dispatch]);

  const handleDeleteResponse = (response) => {
    setShow(false);
    if (empId && response) {
      dispatch(start());
      remove(`employee?id=${empId}`).then((res) => {
        if (res.affectedRows > 0) {
          dispatch(deleteEmployee(empId));
        }
      });
    }
  };

  const handleClose = () => {
    setView(false);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const body =
    <>
      <ul class="list-group list-group-vertical">
        <li class="list-group-item" ><b>Employee Name : </b>{currentVal?.name}</li>
        <li class="list-group-item"><b>Department : </b>{currentVal?.department_name}</li>
      
        <li class="list-group-item"><b>Superviser : </b>{currentVal?.supervisor}</li>
        <li class="list-group-item"><b>Designation : </b>{currentVal?.employee_designation}</li>
      
        <li class="list-group-item"><b>Email : </b>{currentVal?.email}</li>
        <li class="list-group-item"><b>Contact : </b>{currentVal?.contact}</li>
      </ul>
    </>

  return (
    <>
      <div className='row'>
        <div className="col-sm-4 position-relative">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="form-control"
          />
          <span className="fa fa-search department-search-icon"></span>
        </div>
        <div className="col-sm-8">
          <CreateEmployee />
        </div>
      </div>
      {/* <div className='accordion-main'> */}
      <table className="table">
        <thead>
          <tr>
            <th onClick={() => handleSort('id')}>Employee ID <i class="fa-solid fa-sort"> </i></th>

            <th onClick={() => handleSort('name')}>Employee Name <i class="fa-solid fa-sort"> </i></th>

            <th onClick={() => handleSort('department_name')}>Department <i class="fa-solid fa-sort"> </i></th>

            <th onClick={() => handleSort('supervisor')}>Supervisor <i class="fa-solid fa-sort"> </i></th>

            <th onClick={() => handleSort('employee_designation')}>Designation <i class="fa-solid fa-sort"> </i></th>

            <th onClick={() => handleSort('status')}>User Status <i class="fa-solid fa-sort"> </i></th>
            <th colSpan="3" style={{ textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          <EmployeeMasterData setEmpId={setEmpId} setShow={setShow} setView={setView} setCurrentVal={setCurrentVal} searchTerm={searchTerm} sortConfig={sortConfig} />
        </tbody>
      </table>
      <DeleteModal handleDeleteResponse={handleDeleteResponse} show={show} title={"Employee"} />
      <ViewModal handleClose={handleClose} body={body} view={view} title={"Employee Info"} />

      {/* </div> */}

      {/* <div className='accordion-main'>
        <Accordion defaultActiveKey="0">
          <div className='fixedheader'>
            <span><b>Employee ID</b></span>
            <span><b>Employee Name</b></span>
            <span><b>Email</b></span>
            <span><b>Contact Number</b></span>
            <span><b>Department</b></span>
          </div>
          <EmployeeMasterData />
        </Accordion>
      </div> */}
    </>
  );

}

export default EmployeeMaster;